import { API_REQUEST, API_SUCCESS, API_FAILURE, API_UNAUTHORIZED, API_INVALID } from '../actions/Api';
import join from 'lodash/join';
import split from 'lodash/split';

export function clean(type) {
	if (type.indexOf('.')) {
		return split(type, '.')[1];
	} else {
		return type;
	}
}

export function request(type) {
	return join([API_REQUEST, type], '.');
}

export function success(type) {
	return join([API_SUCCESS, type], '.');
}

export function failure(type) {
	return join([API_FAILURE, type], '.');
}

export function invalid(type) {
	return join([API_INVALID, type], '.');
}

export function unauthorized(type) {
	return join([API_UNAUTHORIZED, type], '.');
}



// WEBPACK FOOTER //
// ./src/reducers/helpers.js